import React from 'react'

export default function Copyright() {
  return (
    <>
      <div className="copyright">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <p className="text-center m-0">
                    Copyright © 2025 Unlock Destinations. All Rights Reserved
                </p>
            </div>
        </div>
    </div>
</div>
    </>
  )
}
